import { adaptFormDataFunction } from '@/modules/corporate/modules/database/fields/types';
import { FieldType } from '@/modules/corporate/modules/database/interfaces';

interface Params {
  data?: any;
  fields: FieldType[];
}

const defaultAdaptFormData: adaptFormDataFunction = (data) => data?.value ?? '';

const adaptFormValues = (params: Params) => {
  const { data = {}, fields } = params;
  const initialValues: any = {};

  fields.forEach((field) => {
    const { metadataField, config } = field;
    const adaptFormData = config.Viewer.adaptFormData ?? defaultAdaptFormData;
    initialValues[metadataField.fieldId] = adaptFormData(data[metadataField.fieldId], field);
  });

  // Object.entries<any>(data).forEach(([fieldId, fieldData]) => {
  //   const field = fieldsById[fieldId];
  //   if (!fieldData?.value || !field) {
  //     return;
  //   }
  //   const adaptFormData = field.config.Viewer.adaptFormData || defaultAdaptFormData;
  //   initialValues[fieldId] = adaptFormData(fieldData, field);
  // });

  return initialValues;
};

export default adaptFormValues;
